/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-26 15:43:53
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-04-26 15:44:29
 */

import SavedProjectConfirm from './SavedProjectConfirm';

export default SavedProjectConfirm;
